import { render } from "./SVGModalView.vue?vue&type=template&id=79a9d094"
import script from "./SVGModalView.vue?vue&type=script&lang=js"
export * from "./SVGModalView.vue?vue&type=script&lang=js"

import exportComponent from "/gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__